"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _mapKeys = _interopRequireDefault(require("lodash/mapKeys"));
var _commonCta = require("@mmc/common-cta");
var _text = require("@mmc/text");
var _commonRichText = require("@mmc/common-rich-text");
var _offersList = require("./offers-list.prop-types");
var _offerCard = _interopRequireDefault(require("./offer-card.css"));
var OfferCard = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(OfferCard, _React$PureComponent);
  function OfferCard() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  var _proto = OfferCard.prototype;
  _proto.ctaClickHandler = function ctaClickHandler() {
    var _this$props = this.props,
      offer = _this$props.offer,
      vehicleName = _this$props.vehicleName;
    localStorage.setItem('offerClicked', "" + offer.offerCode + (vehicleName ? "|" + vehicleName : ''));
  };
  _proto.render = function render() {
    var _descriptionsMap$subH,
      _this = this;
    var _this$props2 = this.props,
      className = _this$props2.className,
      offer = _this$props2.offer,
      vehicleName = _this$props2.vehicleName,
      modelDisclaimer = _this$props2.modelDisclaimer,
      showImage = _this$props2.showImage,
      theme = _this$props2.theme,
      labels = _this$props2.labels;
    var descriptionsMap = (0, _mapKeys["default"])(offer.descriptions, 'type');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(_offerCard["default"].offerCardContainer, className)
    }, offer.offerImage && showImage && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", {
      className: "vehicleImage",
      src: offer.offerImage,
      alt: offer.offerImageAltText
    }), offer.legalTextImage && offer.disclaimerData && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        html: offer.legalTextImage
      }),
      className: theme.bodyCopy + " " + _offerCard["default"].greyButton + " " + _offerCard["default"].offerLegalTextImage,
      disclaimerData: offer.disclaimerData
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: _offerCard["default"].modelDisclaimer
    }, modelDisclaimer)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "summary"
    }, offer.cardEyebrowText && /*#__PURE__*/_react["default"].createElement("p", {
      className: "title"
    }, offer.cardEyebrowText), descriptionsMap.subHeadline && /*#__PURE__*/_react["default"].createElement("p", {
      className: "textOffer"
    }, descriptionsMap.subHeadline.text), descriptionsMap.headline.text && offer.disclaimerData && /*#__PURE__*/_react["default"].createElement("a", {
      href: offer.detailPageUrl,
      className: _offerCard["default"].offerHeadlineLink,
      "data-analytics-offer-code": offer.offerCode,
      "data-vehicle-name": vehicleName,
      onClick: function onClick() {
        localStorage.setItem('offerClicked', "" + offer.offerCode + (vehicleName ? "|" + vehicleName : ''));
      }
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: descriptionsMap.headline.text,
      className: "textHeadline",
      disclaimerData: offer.disclaimerData,
      enableEventPropagation: true
    })), (descriptionsMap == null ? void 0 : (_descriptionsMap$subH = descriptionsMap.subHeadline1) == null ? void 0 : _descriptionsMap$subH.text) && offer.disclaimerData && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: descriptionsMap.subHeadline1.text,
      className: theme.headingFour + " " + _offerCard["default"].subHeadlineOne,
      tag: "h4",
      disclaimerData: offer.disclaimerData
    })), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      spanClasses: [_offerCard["default"].ctaBtn],
      data: {
        priority: 'low',
        label: labels.viewOfferCTA,
        url: offer.detailPageUrl,
        ctaProps: {
          'data-analytics-offer-code': offer.offerCode,
          'data-vehicle-name': vehicleName
        }
      },
      mouseDownEvent: function mouseDownEvent() {
        _this.ctaClickHandler();
      }
    }));
  };
  return OfferCard;
}(_react["default"].PureComponent);
exports["default"] = OfferCard;
OfferCard.displayName = 'OfferCard';